import {VariantAttributeType} from "../../definitions/types";

export class VariantAttributeModel {
    private readonly _key: string;
    private readonly _value: string;
    private readonly _unit?: string;

    constructor(variantAttributeType: VariantAttributeType) {
        this._key = variantAttributeType.key;
        this._value = variantAttributeType.value;
        this._unit = variantAttributeType.unit;
    }

    /**
     * @property key
     * @description The key of the variant attribute
     * @returns {string}
     * @example 'Screen Size'
     */
    public get key(): string {
        return this._key;
    }

    /**
     * @property value
     * @description The value of the variant attribute
     * @returns {string}
     * @example '55'
     */
    public get value(): string {
        return this._value;
    }

    /**
     * @property unitOfMeasure
     * @description The unit of the variant attribute
     * @returns {string}
     * @example '""'
     */
    public get unitOfMeasure(): string | undefined {
        return this._unit;
    }

    /**
     * @method toString
     * @description Returns a string representation of the variant attribute
     * @returns {string}
     * @example 'Screen Size: 55"'
     */
    public get toString(): string {
        return `${this._key}: ${this._value}${this._unit ? this._unit : ""}`;
    }
}